import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { SignupService } from 'src/app/services/signup.service';
import { WatcherService } from 'src/app/services/watcher.service';
import { AppState } from 'src/app/store/app.reducer';
@Component({
  selector: 'app-howitworksforhosts',
  templateUrl: './howitworksforhosts.component.html',
  styleUrls: ['./howitworksforhosts.component.css']
})
export class HowitworksforhostsComponent implements OnInit {
  userID;
  token;
  constructor(
    public signUpService: SignupService,
    private toastr: ToastrService,
    private watcherService: WatcherService,
    private router: Router,
    private store: Store<AppState>
  ) {}
  lang;
  ngOnInit(): void {
    this.store.select('auth').subscribe(state => {
      this.token = state.token;
      this.userID = state.user?.id;
    })
    this.watcherService.getLang().subscribe(
      lang => {
        this.lang = lang;
      }
    )
    
  }
  goBecomeAHost() {
    if (this.token) {
      this.toastr.error("The same email address can not be used to be both a shopper and a host. Please, try to sign up with another email address.", 'Error');
    }
    else if (!this.token) {
      this.router.navigate(['/', this.lang, 'become-a-host'])
    }
  }
}
